// extracted by mini-css-extract-plugin
export var attribution = "_an-4";
export var authorName = "_an-5";
export var quote = "_an-3";
export var testimonial = "_an-2";
export var trustedBy = "_an-0";
export var trustedByLabel = "_an-1";